import { Component, ContentChildren, forwardRef, Input, QueryList } from "@angular/core";

import { UniAccordionGroupComponent } from "./accordion-group/accordion-group.component";

@Component({
  selector: "uni-accordion",
  templateUrl: "./accordion.component.html",
  styleUrls: ["./accordion.component.scss"],
})
export class UniAccordionComponent {
  /** If `true` the element will adapt to small screens*/
  @Input() public isResponsive = true;

  /** If `true` when open a group the others groups will close */
  @Input() public closeOthers = false;

  /** if `true` the element will has child accordion styles. Use it when insert a accordion inside a accordion group */
  @Input() public isChild = false;

  /** if `true` will show marks indicating if is open or close */
  @Input() public showExpandedIcon = false;

  /** specify the text of the closed summary in mobile */
  @Input() public closedText: string = "Ver Resumen";

  /** specify the text of the opened summary in mobile */
  @Input() public openedText: string = "Ocultar Resumen";

  @Input() public title: string = "Resumen";

  /** @ignore */
  @ContentChildren(forwardRef(() => UniAccordionGroupComponent)) public groups = new QueryList<UniAccordionGroupComponent>();

  /** @ignore */
  public isAccordionOpen: boolean = false;

  /** @ignore */
  public toogleMobileAccordion(): void {
    this.isAccordionOpen = !this.isAccordionOpen;
  }
}
